import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useTranslation } from "react-i18next";

const ViewStudentLeave = () => {
    const { t } = useTranslation();
    
    return (
        <>
            <div className="px-2 px-md-4">
                <div className="my-4 col-12 d-flex justify-content-between align-items-center">
                    <h5 className="">{t("View Student Leave")}</h5>
                </div>

                <div className="row mt-3">
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("From Date")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input style={{ width: "28rem" }}
                            type="date"
                            name="fromDate"
                            className="form-control"
                            required
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("To Date")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input style={{ width: "28rem" }}
                            type="date"
                            name="toDate"
                            className="form-control"
                            required
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Class Name")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="class"
                            className="common-input form-select"
                        >
                            <option value="">Select class</option>
                            <option value="">12</option>
                            <option value="">11</option>
                            <option value="">10</option>
                            <option value="">09</option>
                            <option value="">08</option>
                            <option value="">07</option>
                            <option value="">06</option>
                            <option value="">05</option>
                            <option value="">04</option>
                            <option value="">03</option>
                            <option value="">02</option>
                            <option value="">01</option>
                        </select>
                    </div>
                </div>

                <div className="row mt-3">
                <div className="col-md-4">
                        <label className="form-label">
                            {t("Section Name")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="section"
                            className="common-input form-select"
                        >
                            <option value="">Select section</option>
                            <option value="">A</option>
                            <option value="">B</option>
                            <option value="">C</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Student Name")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="student_name"
                            className="common-input form-select"
                        >
                            <option value="">Select student</option>
                            <option value="">Abhay</option>
                            <option value="">Bindra</option>
                            <option value="">Chaman</option>
                        </select>
                    </div>
                </div>

                <div className="row col-7 mt-5 d-flex mx-1">
                    <button type="submit"
                        className="btn me-2 col-md-2"
                        id="btn"
                    >
                        {t("Search")}
                    </button>
                    <button
                        type="submit"
                        className="btn btn-secondary me-2 col-md-2"
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        type="submit"
                        className="btn btn-success me-2 col-md-2"
                    >
                        {t("Export in CSV")}
                    </button>
                    <button
                        type="submit"
                        className="btn btn-success me-2 col-md-2"
                    >
                        {t("PDF")}
                    </button>
                </div>

                <div className="Table mb-4">
                    <TableContainer
                        component={Paper}
                        style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
                        className="my-4"
                    >
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("Sr. No.")}</TableCell>
                                    <TableCell align="left">{t("Student Name")}</TableCell>
                                    <TableCell align="left">{t("Class")}</TableCell>
                                    <TableCell align="left">{t("Apply On")}</TableCell>
                                    <TableCell align="left">{t("Reason")}</TableCell>
                                    <TableCell align="left">{t("Leave Type")}</TableCell>
                                    <TableCell align="left">{t("Duration")}</TableCell>
                                    <TableCell align="left">{t("Status")}</TableCell>
                                    <TableCell align="left">{t("Day Type")}</TableCell>
                                    <TableCell align="left">{t("Modified By")}</TableCell>
                                    <TableCell align="left">{t("Action")}</TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </>
    );
}

export default ViewStudentLeave